import { render, staticRenderFns } from "./TablaOrigenOferta.vue?vue&type=template&id=11dccf0c"
import script from "./TablaOrigenOferta.vue?vue&type=script&lang=js"
export * from "./TablaOrigenOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports